import React from 'react'
import { closeModal, galochka } from '../../../assets';
import { Link } from 'react-router-dom';

const Modals = ({isOpen, link, onClose,childrenStyle, children,galocka, modalName}) => {
    if (!isOpen) return null;
  return (
    <div className='flex justify-center z-20 fixed h-full w-full top-0 right-0 items-center'>
      <div className="bg-white fixed  z-50 rounded-[5px] w-[332px] sm:w-[430px]">
      <div className='flex justify-between items-center pb-[18px] border-b-[1px] border-gray-borderBottomGray w-full pt-[22px] border-solid'>
            <div onClick={onClose} className='ml-[18px] p-[5px]'><img src={closeModal} alt="" /></div>
            <div className='font-medium text-[15px] font-inter'>{modalName}</div>
            <Link to={link}>
            <div className='mr-[18px] p-[5px]'>{galocka||<img src={galochka} alt="" />}</div>
            </Link>
        </div>
        <div className={`relative overflow-x-auto ${childrenStyle}`} >{children}</div>
      </div>
        <div onClick={onClose} className="bg-gray-modalBackground z-40 fixed top-0 left-0 w-full h-full flex justify-center items-center ">
    </div>
    </div>
  )
}

export default Modals